module.exports = __webpack_public_path__ + "img/file-csv.2f43097e.svg";